
import { IBlockMultimediaProgressModel } from 'models/block.model'
import api from '../..'

export const UpdateMultimediaBlockProgress = (blockInstanceId: number, courseId: number, progress: number, duration: number) => {
  return api.put(`block_instances_progress/${blockInstanceId}`, {
    progress,
    block_instance_id: blockInstanceId,
    course_id: courseId,
    duration
  }).then(
    ({
      data
    }): IBlockMultimediaProgressModel => {
      return data
    }
  )
}
